import { TFunction } from 'i18next'

import { SiteUnscope, VisibilityInCenter } from './types'

export const SITES_PAGE_LIMIT = 25

export const SITES_LIST_QUERIES = ['SearchSitesUnscoped', 'AggSitesUnscopedStates', 'CountSitesUnscoped']

export const VISIBILITY_VALUES: VisibilityInCenter[] = ['strength', 'auto', 'hidden']

type SiteStateConfig = {
  translationKey: string
  color: string
  bgcolor: string
}

export const SITE_STATE_CONFIG: Record<string, SiteStateConfig> = {
  'En production': { translationKey: 'in_production', color: '#587F31', bgcolor: '#E6F0D7' },
  'Etude': { translationKey: 'study', color: '#2570EB', bgcolor: '#DBE8FE' },
  'VSR': { translationKey: 'vsr', color: '#8B5CF6', bgcolor: '#EDE9FE' },
  'Fin exploitation': { translationKey: 'end_of_operation', color: '#9A6700', bgcolor: '#FEF4E9' },
  'Abandon': { translationKey: 'abandoned', color: '#DC2626', bgcolor: '#FEE2E2' }
}

export const DEFAULT_SITE_STATE_COLORS = { color: '#7A8096', bgcolor: '#F6F7F8' }

const IN_PRODUCTION_STATE = 'En production'
const ETUDE_STATE = 'Etude'

export const isVisibleInCenter = ({ state, has_active_project, has_process, visibility_in_center }: SiteUnscope) => {
  if (![IN_PRODUCTION_STATE, ETUDE_STATE].includes(state || '')) return false
  if (visibility_in_center === 'hidden') return false
  if (visibility_in_center === 'strength') return true
  return state === IN_PRODUCTION_STATE || Boolean(has_active_project && has_process)
}

export const getSiteStateLabel = (t: TFunction, state: string) => {
  const config = SITE_STATE_CONFIG[state]
  if (!config) return state
  return t(`admin_sites.state.${config.translationKey}`)
}
